module.exports = "/_next/static/images/wrath_white_appstore_playstore_2026-17c306399c0d603330282ff622d0bde6.webp";